
import React from 'react';
import { Input } from '../../../../../components/ui/input';
import { BaseFieldPreviewProps } from './previewUtils';

const FileFieldPreview: React.FC<BaseFieldPreviewProps> = ({ field, renderDescription }) => {
  return (
    <div>
      {renderDescription()}
      <Input type="file" disabled className="bg-white" />
    </div>
  );
};

export default FileFieldPreview;
